import {
  CmsContentWithCollection,
  CollectionConfig,
  CollectionTileContext,
  DepartmentsEnum,
  PageMeta,
  SearchParameters,
  CollectionHeader,
  CollectionType,
  CollectionTileMission,
  collectionTypes,
} from './types'
import { Collections } from './config'
import { BRAND_LABEL, STORES } from '@moonpig/web-core-brand/config'
import { Region } from '@moonpig/web-core-types'

const pageTitle = 'Collections'

const buildCollectionTilePath = (
  type: CollectionType,
  context?: CollectionTileContext,
): string => {
  return context === CollectionTileContext.CrossSell
    ? `/uk/collections/${type}?d=all_gifts`
    : `/uk/collections/${type}`
}

const createSearchParameters = ({
  promotionId,
}: CollectionConfig): SearchParameters => ({
  searchTerm: '',
  departments: [
    DepartmentsEnum.ALL_CARDS,
    DepartmentsEnum.ALL_GIFTS,
    DepartmentsEnum.ALL_FLOWERS_AND_PLANTS,
  ],
  searchFilters: {
    promotionId,
    variants: undefined,
    facets: [],
  },
  preAppliedFacets: [],
  sponsoredProducts: [],
})

const createCmsContent = (
  header: CollectionHeader,
): CmsContentWithCollection => ({
  offer: '',
  title: pageTitle,
  description: null,
  breadcrumbsItems: [],
  header,
})

const createPageMeta = (
  type: CollectionType,
  { header }: CollectionConfig,
  region: Region,
): PageMeta => {
  const canonicalSubPath = buildCollectionTilePath(type)
  return {
    title: header.title,
    description: header.description,
    canonicalSubPath,
    noIndex: true,
    openGraph: {
      url: `${process.env.HOST_URL}${canonicalSubPath}`,
      title: header.title,
      description: header.description,
      image: { url: header.image },
      locale:
        STORES.find(store => store.id === region)?.locale.language.replace(
          '-',
          '_',
        ) ?? '',
      siteName: BRAND_LABEL,
      type: 'website',
    },
    structuredData: [],
  }
}

export const createInternalContent = ({
  collectionType,
  region,
}: {
  collectionType: CollectionType
  region: Region
}) => {
  const collection = Collections[collectionType]

  return {
    searchParameters: createSearchParameters(collection),
    cmsContent: createCmsContent(collection.header),
    missionId: collection.missionId,
    mission: collection.mission,
    pageMeta: createPageMeta(collectionType, collection, region),
  }
}

export const createTileContent = (
  mission: CollectionTileMission,
  context?: CollectionTileContext,
) => {
  const tilesForMission =
    mission === CollectionTileMission.Birthday
      ? collectionTypes
      : /* istanbul ignore next */ []

  const tiles = tilesForMission.map(type => {
    const collection = Collections[type]

    return {
      ...collection.tile,
      path: buildCollectionTilePath(type, context),
      missionId: collection.missionId,
      mission: collection.mission,
    }
  })

  return {
    tiles,
  }
}
